<template>
  <div>
    <h1>Administradores</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar administrador"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <!--
      <b-modal ref="my-modal" hide-footer title="Deshabilitar administrador">
        <div class="d-block text-center">
          <h3>Confirmar la deshabilitación del administrador {{ user.name }} {{ user.lastName }}</h3>
          <b-button class="mt-2" variant="outline-warning" block @click="disable(user)">Confirmar</b-button>
        </div>
      </b-modal>-->
      <b-table
          show-empty
          stacked="md"
          :items="getUsers"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >
          <template v-slot:cell(actions)='row'>
            <b-button style="margin: 2px" class="btn-sm" :disabled="row.item.active === 0" variant="outline-success" size="md" @click="showUserInfo(row.item)">
              Editar
            </b-button>

            <b-button style="margin: 2px" v-if="row.item.active === 1" variant="outline-warning" size="sm" @click="showDisableModal(row.item)" class="btn-sm">
              Deshabilitar
            </b-button>

            <b-button style="margin: 2px" v-if="row.item.active === 0" variant="outline-secondary" size="sm" @click="showEnableModal(row.item)" class="btn-sm">
              Habilitar
            </b-button>
          </template>
          <template v-slot:cell(motivos)='row'>
            <b-button class="btn-sm" v-if="!row.item.active" variant="outline-primary" @click="showEvidence(row.item)">Visualizar evidencia</b-button>
          </template>
          <template v-slot:cell(active)='row'>
            <p>{{row.item.active === 1 ? 'Habilitado' : 'Deshabilitado'}}</p>
          </template>
          <template v-slot:cell(phoneNumber)='row'>
            <p>{{row.item.phoneNumber.replace('+521','')}}</p>
          </template>
          <template slot="name" slot-scope="row">{{ row.value.first }} {{ row.value.last }}</template>

          <template slot="isActive" slot-scope="row">{{ row.value ? 'Yes :)' : 'No :(' }}</template>

          <template slot="actions" slot-scope="row">
            <b-button
              size="sm"
              @click="info(row.item, row.index, $event.target)"
              class="mr-1"
            >Info modal</b-button>
            <b-button
              size="sm"
              @click="row.toggleDetails"
            >{{ row.detailsShowing ? 'Hide' : 'Show' }} Details</b-button>
          </template>

          <template slot="row-details" slot-scope="row">
            <b-card>
              <ul>
                <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value+'test' }}</li>
              </ul>
            </b-card>
          </template>
          <template slot="action">
            <div class="text-nowrap">
              <!--
              <button type="button" class="btn btn-outline-danger mr-2 mb-2">Decline</button>
              -->
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
    </b-row>
    <div>
      <b-modal
        size="lg"
        ok-only
        id="modal-prevent-closing-motivos"
        ref="modal"
        title="Motivos de Baja"
        @show="modal"
        @hidden="hideModal"
      >
      <b-table
        show-empty
        stacked="md"
        :items="disabledUser"
        :fields="fieldsMotivos"
        :per-page="1"
      >
        <template v-slot:cell(acciones)="row">
          <b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="viewEvidence(row.item.fileUrl)">Evidencia</b-button>
        </template>
      </b-table>
      </b-modal>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
// import * as firebase from 'firebase/app'
import { Modal } from 'ant-design-vue'
import headers from '@/config/headers.js'
const MUTATION_DISABLE_USER = gql`
  mutation disableUser($id: Int!, $username: String){
    disableUser(id: $id, username: $username){
      id
      name
      email
      userName
      active
      role{
        id
        name
      }
    }
  }`
const MUTATION_ENABLE_USER = gql`
  mutation enableUser($id: Int!, $username: String){
    enableUser(id: $id, username: $username){
      message
    }
  }
`
const DELETE_SESSION = gql`
mutation deleteSession($user: String, $app: String){
  deleteSession(session: { user: $user app: $app }){
    success
    message
  }
}
`
const ADMIN_RESET_PASSWORD = gql`
  mutation adminResetPassword($username: String){
    adminResetPassword(username: $username){
      message
    }
  }
`
const UPDATE_USER_BAN = gql`
  mutation updateUserBan($userId: Int $enabledBy: String){
    updateUserBan(userId: $userId, enabledBy: $enabledBy){
      id
      fileUrl
    }
  }
`
const GET_DISABLED_USER_EVIDENCE = gql`
  query getNewestUserBan($userId: Int){
    getNewestUserBan(userId: $userId){
      id
      reason
      fileUrl
      disabledBy
      user{
        id
        email
      }
    }
  }
`
export default {
  name: 'users',
  data() {
    return {
      fields: [
        // { key: 'id', label: 'Id' },
        { key: 'name', label: 'Nombre(s)' },
        { key: 'lastName', label: 'Apellidos' },
        { key: 'email', label: 'Correo electrónico' },
        // { key: 'userName', label: 'Nombre de usuario' },
        { key: 'phoneNumber', label: 'Número de teléfono ' },
        { key: 'role.name', label: 'Rol' },
        { key: 'active', label: 'Estatus' },
        { key: 'actions', label: 'Acciones' },
        { key: 'motivos', label: 'Motivos de Baja' },
      ],
      fieldsMotivos: [
        { key: 'reason', label: 'Motivo', sortable: true, sortDirection: 'desc' },
        { key: 'user.email', label: 'Administrador' },
        { key: 'disabledBy', label: 'Deshabilitado por:' },
        { key: 'acciones', label: 'Acciones' },
      ],
      modal: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [10, 20, 50],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      disabledUser: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      user: {},
      getUsers: [],
    }
  },
  apollo: {
    getUsers: {
      query: gql`
      query getUsers{
        getUsers{
          id
          name
          lastName
          email
          userName
          phoneNumber
          active
          role{
            id
            name
          }
        }
      }
      `,
      context: headers(),
      result({ data }) {
        this.totalRows = this.getUsers.length
      },
    },
  },
  methods: {
    hideModal() {
      this.$refs.modal.hide()
    },
    viewEvidence(fileUrl) {
      window.open(fileUrl)
    },
    showEvidence(user) {
      this.$apollo.query({
        query: GET_DISABLED_USER_EVIDENCE,
        context: headers(),
        variables: {
          userId: parseInt(user.id),
        },
      })
        .then(({ data }) => {
          this.disabledUser = [data.getNewestUserBan]
          this.$refs.modal.show()
        })
        .catch(error => {
          console.log(error)
        })
    },
    closeModal() {
      this.$refs['my-modal'].hide()
    },
    showResetPasswordModal(user) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas restablecer la contraseña del administrador ${user.email}?`,
        cancelText: 'Cancelar',
        okText: 'Aceptar',
        onOk: () => {
          this.resetPassword(user)
        },
      })
    },
    showDisableModal(user) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas deshabilitar el administrador ${user.email}?`,
        cancelText: 'Cancelar',
        okText: 'Aceptar',
        onOk: () => {
          this.$router.push({ name: 'disableAdmin', params: user })
          // this.disable(user)
        },
      })
    },
    showEnableModal(user) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas habilitar el administrador ${user.email}?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.enable(user)
        },
      })
    },
    resetPassword(user) {
      this.$apollo.mutate({
        mutation: ADMIN_RESET_PASSWORD,
        context: headers(),
        variables: {
          username: user.username,
        },
      })
        .then(data => {
          console.log(data)
          this.makeToast(true, 'success', '', `Se restableció la contraseña del usuario ${user.email}`)
        })
        .catch(error => {
          console.log(error)
          this.makeToast(true, 'warning', 'Error', `No se pudo restablecer la contraseña del usuario ${user.email} inténtelo después de un tiempo`)
        })
    },
    disable(user) {
      // console.log(user)
      this.$apollo.mutate({
        mutation: DELETE_SESSION,
        context: headers(),
        variables: {
          user: user.email,
          app: 'ADMIN',
        },
      })
        .then(data => {
          // console.log(data)
        })
        .catch(error => {
          console.log(error)
        })
      // firebase.firestore().collection('adminSession').doc(user.email).delete()
      this.$apollo.mutate({
        mutation: MUTATION_DISABLE_USER,
        variables: {
          id: parseInt(user.id),
          username: user.email,
        },
        context: headers(),
      })
        .then(data => {
          console.log(data)
          this.makeToast(true, 'success', 'usuario deshabilitado', `El usuario ${user.email} se ha deshabilitado`)
        })
        .catch(error => {
          console.log(error)
        })
    },
    enable(user) {
      this.$apollo.mutate({
        mutation: MUTATION_ENABLE_USER,
        variables: {
          id: parseInt(user.id),
          username: user.email,
        },
        context: headers(),
      })
        .then(result => {
          // console.log(result)
          this.$apollo.mutate({
            mutation: UPDATE_USER_BAN,
            context: headers(),
            variables: {
              userId: parseInt(user.id),
              enabledBy: this.$store.state.user.email,
            },
          })
            .then(data => {
              console.log(data)
              this.makeToast(true, 'success', 'usuario habilitado', `El usuario ${user.email} se ha habilitado`)
              this.$apollo.queries.getUsers.refetch()
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
    showUserInfo(user) {
      this.$router.push({ path: '/admin/administrador/:id', name: 'admin-info', params: { id: user.id } })
      // console.log(user)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  mounted() {
    this.$apollo.queries.getUsers.refetch()
  },
}
</script>
<style scoped>

</style>
